import { render } from "./ComponentProjects.vue?vue&type=template&id=34c776c4&scoped=true"
import script from "./ComponentProjects.vue?vue&type=script&lang=js"
export * from "./ComponentProjects.vue?vue&type=script&lang=js"

import "./ComponentProjects.vue?vue&type=style&index=0&id=34c776c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c776c4"]])

export default __exports__